namespace TabAurous.Stock {
    export namespace StockByPurchaseApprovalService {
        export const baseUrl = 'Stock/StockByPurchaseApproval';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Stock.Repositories.StockByPurchaseApproval>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Stock/StockByPurchaseApproval/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>StockByPurchaseApprovalService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
